import { render, staticRenderFns } from "./SwamtStartParent25.vue?vue&type=template&id=04ab9742&scoped=true&"
import script from "./SwamtStartParent25.vue?vue&type=script&lang=js&"
export * from "./SwamtStartParent25.vue?vue&type=script&lang=js&"
import style0 from "./SwamtStartParent25.vue?vue&type=style&index=0&id=04ab9742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab9742",
  null
  
)

export default component.exports